import { Step, StepLabel, Stepper } from '@mui/material'

interface AppStepsProps {
    steps: string[],
    actualStep: number
}

export default function AppSteps({ steps, actualStep }: Readonly<AppStepsProps>) {
    return (
        <Stepper activeStep={actualStep - 1} alternativeLabel sx={{marginBottom: '1.5rem'}}>
            {steps.map((label, idx) => <Step key={label} completed={actualStep > (idx + 1)}>
                <StepLabel>{label}</StepLabel>
            </Step>)}
        </Stepper>
    )
}
